export default __webpack_public_path__ + "static/media/remove.3c1864c5.svg";